import { render } from "./translateItems.vue?vue&type=template&id=86443d46&scoped=true"
import script from "./translateItems.vue?vue&type=script&lang=js"
export * from "./translateItems.vue?vue&type=script&lang=js"

import "./translateItems.vue?vue&type=style&index=0&id=86443d46&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86443d46"]])

export default __exports__